<template>
  <div class="required-field-note">
    <IconEmbedded class="required-field-note__asterix" name="asterix_3" :size="15" />
    <span class="required-field-note__text"><slot /></span>
  </div>
</template>

<script setup lang="ts">
// Components
import IconEmbedded from "@components/ui/IconEmbedded.vue";
</script>

<style scoped lang="scss">
// Required field note ========================================================
.required-field-note {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: rgba(255, 0, 0, 1);
  font: 14px/18px sans-serif;
  vertical-align: middle;
  white-space: nowrap;

  &__asterix {
    :deep(svg) {
      fill: rgba(255, 0, 0, 1);
    }
  }

  &__text {
    padding-left: 12px;
    position: relative;

    &::before {
      content: "-";
      position: absolute;
      inset: 0 auto auto 3px;
    }
  }
}
</style>
